import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

export default function StudentAttendance() {
  const [attendance, setAttendance] = useState([])
  const [stats, setStats] = useState({ present:0, absent:0, late:0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetch() {
      const { data: { user } } = await supabase.auth.getUser()
      const { data: acc } = await supabase.from('student_accounts').select('student_id').eq('id', user.id).single()
      if (!acc) { setLoading(false); return }
      const { data } = await supabase.from('attendance').select('*').eq('student_id', acc.student_id).order('date', { ascending: false })
      setAttendance(data || [])
      setStats({
        present: data?.filter(a=>a.status==='present').length||0,
        absent:  data?.filter(a=>a.status==='absent').length||0,
        late:    data?.filter(a=>a.status==='late').length||0,
      })
      setLoading(false)
    }
    fetch()
  }, [])

  const statusCfg = {
    present: { label:'Present', cls:'badge-success' },
    absent:  { label:'Absent',  cls:'badge-danger'  },
    late:    { label:'Late',    cls:'badge-warning'  },
  }

  const total = stats.present + stats.absent + stats.late
  const pct = total ? Math.round(stats.present/total*100) : null

  if (loading) return <div className="empty">Loading...</div>

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h2 style={{ fontSize:20, fontWeight:500 }}>My Attendance</h2>
        {pct !== null && (
          <span className={`badge ${pct>=80?'badge-success':pct>=60?'badge-warning':'badge-danger'}`} style={{ fontSize:14, padding:'5px 14px' }}>
            {pct}% Present
          </span>
        )}
      </div>
      <div style={{ display:'flex', gap:12, marginBottom:16 }}>
        {[
          { l:'Present', v:stats.present, c:'var(--success)', bg:'var(--success-bg)' },
          { l:'Absent',  v:stats.absent,  c:'var(--danger)',  bg:'var(--danger-bg)'  },
          { l:'Late',    v:stats.late,    c:'var(--warning)', bg:'var(--warning-bg)' },
        ].map(s => (
          <div key={s.l} style={{ flex:1, background:s.bg, borderRadius:12, padding:12, textAlign:'center' }}>
            <div style={{ fontSize:26, fontWeight:700, color:s.c }}>{s.v}</div>
            <div style={{ fontSize:12, color:s.c, fontWeight:500 }}>{s.l}</div>
          </div>
        ))}
      </div>
      {attendance.length === 0 ? <div className="empty">No attendance records</div> : (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          <table>
            <thead><tr><th>Date</th><th>Status</th></tr></thead>
            <tbody>
              {attendance.map(a => (
                <tr key={a.id}>
                  <td style={{ fontWeight:500 }}>{a.date}</td>
                  <td><span className={`badge ${statusCfg[a.status].cls}`}>{statusCfg[a.status].label}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}